import { RoutePath } from '@business/seller';
var PlatformPaths = RoutePath.PlatformPaths;
var getSubmoduleRelativePaths = RoutePath.Utils.getSubmoduleRelativePaths;
var PlatformRelativePaths = getSubmoduleRelativePaths(PlatformPaths, '/platform');
export default PlatformRelativePaths;